import { Button } from "@mui/material";
import React from "react";

const DashTabs = (props) => {
    const { show, setShow } = props;
  return (
    <div className="Dash-table mt-4" style={{ height: "50px" }}>
      <div style={{ float: "right" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <Button
            variant="contained"
            id="btn"
            style={{ padding: "10px" }}
            onClick={() => setShow(false)}
          >
            x Close
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DashTabs;
